import { PropaneSharp } from "@mui/icons-material";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;
// mSet = more settings eg. mSetLoading = more settings loading
let initialState = {
  mSetLoading: false,
  mSetSuccess: false,
  mSetError: false,
  mSetMessage: null,

  mSetGetLoading: false,
  mSetGetSuccess: false,
  mSetGetError: false,
  mSetGetMessage: null,
  mSetGetData: null,

  mSetGetAttLoading: false,
  mSetGetAttSuccess: false,
  mSetGetAttError: false,
  mSetGetAttMessage: null,
  mSetGetAttData: null,

  mSetGetAttModLoading: false,
  mSetGetAttModSuccess: false,
  mSetGetAttModError: false,
  mSetGetAttModMessage: null,
  mSetGetAttModData: null,

  umSetLoading: false,
  umSetSuccess: false,
  umSetError: false,
  umSetMessage: null,

  umSetGetLoading: false,
  umSetGetSuccess: false,
  umSetGetError: false,
  umSetGetMessage: null,
  umSetGetData: null,

  umSetGetAttLoading: false,
  umSetGetAttSuccess: false,
  umSetGetAttError: false,
  umSetGetAttMessage: null,
  umSetGetAttData: null,

  umSetGetAttModLoading: false,
  umSetGetAttModSuccess: false,
  umSetGetAttModError: false,
  umSetGetAttModMessage: null,
  umSetGetAttModData: null,
};


const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;
const userId = user?.user_id;
const accountType = user?.account_type;

export const getAttendModule = createAsyncThunk(
  "getAttendModule",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const getAttendOptions = createAsyncThunk(
  "getAttendOptions",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const getMoreSettings = createAsyncThunk(
  "getMoreSettings",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const saveMoreSettings = createAsyncThunk(
  "saveMoreSettings",
  async (body) => {
    const { path, data } = body;
    const url = baseUrl + path;

    const result = {
      data: {
        status: 200,
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };
    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(url, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              let data = {
                response: {
                  data: [],
                  message: "No Internet Connection Found",
                  success: false,
                },
              };
              return data;
            } else {
              return error;
            }
          });
  }
);

// Update --------------------------------------------
export const getAttendModuleOne = createAsyncThunk(
  "getAttendModuleOne",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const getAttendOptionsOne = createAsyncThunk(
  "getAttendOptionsOne",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const getMoreSettingsOne = createAsyncThunk(
  "getMoreSettingsOne",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const saveMoreSettingsOne = createAsyncThunk(
  "saveMoreSettingsOne",
  async (body) => {
    const { path, data } = body;
    const url = baseUrl + path;

    const result = {
      data: {
        status: 200,
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };
    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(url, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              let data = {
                response: {
                  data: [],
                  message: "No Internet Connection Found",
                  success: false,
                },
              };
              return data;
            } else {
              return error;
            }
          });
  }
);

const moreSettingSlice = createSlice({
  name: "branch",
  initialState,

  reducers: {
    initMoreSettState: (state) => {
      state.mSetLoading = false;
      state.mSetSuccess = false;
      state.mSetError = false;
      state.mSetMessage = null;

      state.mSetGetLoading = false;
      state.mSetGetSuccess = false;
      state.mSetGetError = false;
      state.mSetGetMessage = null;

      state.mSetGetAttLoading = false;
      state.mSetGetAttSuccess = false;
      state.mSetGetAttError = false;
      state.mSetGetAttMessage = null;
      state.mSetGetAttData = null;

      state.mSetGetAttModLoading = false;
      state.mSetGetAttModSuccess = false;
      state.mSetGetAttModError = false;
      state.mSetGetAttModMessage = null;
      state.mSetGetAttModData = null;
      // -------------------------------------
      state.umSetLoading = false;
      state.umSetSuccess = false;
      state.umSetError = false;
      state.umSetMessage = null;

      state.umSetGetLoading = false;
      state.umSetGetSuccess = false;
      state.umSetGetError = false;
      state.umSetGetMessage = null;

      state.umSetGetAttLoading = false;
      state.umSetGetAttSuccess = false;
      state.umSetGetAttError = false;
      state.umSetGetAttMessage = null;
      state.umSetGetAttData = null;

      state.umSetGetAttModLoading = false;
      state.umSetGetAttModSuccess = false;
      state.umSetGetAttModError = false;
      state.umSetGetAttModMessage = null;
      state.umSetGetAttModData = null;
    },
    initAttModule: (state) => {
      state.mSetGetAttModLoading = false;
      state.mSetGetAttModSuccess = false;
      state.mSetGetAttModError = false;
      state.mSetGetAttModMessage = null;
      state.mSetGetAttModData = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getAttendModule.pending, (state, action) => {
      state.mSetGetAttModLoading = true;
      state.mSetGetAttModSuccess = false;
      state.mSetGetAttModError = false;
      state.mSetGetAttModMessage = null;
      state.mSetGetAttModData = null;
    });
    builder.addCase(getAttendModule.fulfilled, (state, action) => {
      state.mSetGetAttModLoading = false;
      state.mSetGetAttModSuccess = true;
      state.mSetGetAttModError = false;
      state.mSetGetAttModMessage = action.payload.data.message;
      state.mSetGetAttModData = action.payload.data.data;
    });
    builder.addCase(getAttendModule.rejected, (state, action) => {
      state.mSetGetAttModLoading = false;
      state.mSetGetAttModSuccess = false;
      state.mSetGetAttModError = true;
      state.mSetGetAttModMessage = action.payload.data.message;
      state.mSetGetAttModData = null;
    });
    // Get Attend options
    builder.addCase(getAttendOptions.pending, (state, action) => {
      state.mSetGetAttLoading = true;
      state.mSetGetAttSuccess = false;
      state.mSetGetAttError = false;
      state.mSetGetAttMessage = null;
      state.mSetGetAttData = null;
    });
    builder.addCase(getAttendOptions.fulfilled, (state, action) => {
      state.mSetGetAttLoading = false;
      state.mSetGetAttSuccess = true;
      state.mSetGetAttError = false;
      state.mSetGetAttMessage = action.payload.data.message;
      state.mSetGetAttData = action.payload.data.data;
    });
    builder.addCase(getAttendOptions.rejected, (state, action) => {
      state.mSetGetAttLoading = false;
      state.mSetGetAttSuccess = false;
      state.mSetGetAttError = true;
      state.mSetGetAttMessage = action.payload.data.message;
      state.mSetGetAttData = null;
    });
    // Get more settings
    builder.addCase(getMoreSettings.pending, (state, action) => {
      state.mSetGetLoading = true;
      state.mSetGetSuccess = false;
      state.mSetGetError = false;
      state.mSetGetMessage = null;
      state.mSetGetData = null;
    });
    builder.addCase(getMoreSettings.fulfilled, (state, action) => {
      state.mSetGetLoading = false;
      state.mSetGetSuccess = true;
      state.mSetGetError = false;
      state.mSetGetMessage = action.payload.data.message;
      state.mSetGetData = action.payload.data.data;
    });
    builder.addCase(getMoreSettings.rejected, (state, action) => {
      state.mSetGetLoading = false;
      state.mSetGetSuccess = false;
      state.mSetGetError = true;
      // state.mSetGetMessage = action.payload.data.message;
      state.mSetGetData = null;
    });
    // To create branch
    builder.addCase(saveMoreSettings.pending, (state, action) => {
      state.mSetLoading = true;
      state.mSetSuccess = false;
      state.mSetError = false;
      state.mSetMessage = null;
    });
    builder.addCase(saveMoreSettings.fulfilled, (state, action) => {
      state.mSetLoading = false;
      state.mSetSuccess =
        action.payload.status == 200
          ? action.payload.data.status == true
            ? true
            : false
          : false;
      state.mSetError =
        action.payload.status == 200
          ? action.payload.data.status == true
            ? false
            : true
          : true;
      state.mSetMessage =
        action.payload.status == 200
          ? action.payload.data.status == true
            ? action.payload.data.message
            : action.payload.data.message
          : action.payload.response.data.message;
    });
    builder.addCase(saveMoreSettings.rejected, (state, action) => {
      state.mSetLoading = false;
      state.mSetSuccess = false;
      state.mSetError = true;
      state.mSetMessage = action.payload.data.message;
    });

    builder.addCase(getAttendModuleOne.pending, (state, action) => {
      state.umSetGetAttModLoading = true;
      state.umSetGetAttModSuccess = false;
      state.umSetGetAttModError = false;
      state.umSetGetAttModMessage = null;
      state.umSetGetAttModData = null;
    });
    builder.addCase(getAttendModuleOne.fulfilled, (state, action) => {
      state.umSetGetAttModLoading = false;
      state.umSetGetAttModSuccess = true;
      state.umSetGetAttModError = false;
      state.umSetGetAttModMessage = action.payload.data.message;
      state.umSetGetAttModData = action.payload.data.data;
    });
    builder.addCase(getAttendModuleOne.rejected, (state, action) => {
      state.umSetGetAttModLoading = false;
      state.umSetGetAttModSuccess = false;
      state.umSetGetAttModError = true;
      state.umSetGetAttModMessage = action.payload.data.message;
      state.umSetGetAttModData = null;
    });
    // Get Attend options
    builder.addCase(getAttendOptionsOne.pending, (state, action) => {
      state.umSetGetAttLoading = true;
      state.umSetGetAttSuccess = false;
      state.umSetGetAttError = false;
      state.umSetGetAttMessage = null;
      state.umSetGetAttData = null;
    });
    builder.addCase(getAttendOptionsOne.fulfilled, (state, action) => {
      state.umSetGetAttLoading = false;
      state.umSetGetAttSuccess = true;
      state.umSetGetAttError = false;
      state.umSetGetAttMessage = action.payload.data.message;
      state.umSetGetAttData = action.payload.data.data;
    });
    builder.addCase(getAttendOptionsOne.rejected, (state, action) => {
      state.umSetGetAttLoading = false;
      state.umSetGetAttSuccess = false;
      state.umSetGetAttError = true;
      state.umSetGetAttMessage = action.payload.data.message;
      state.umSetGetAttData = null;
    });
    // Get more settings
    builder.addCase(getMoreSettingsOne.pending, (state, action) => {
      state.umSetGetLoading = true;
      state.umSetGetSuccess = false;
      state.umSetGetError = false;
      state.umSetGetMessage = null;
      state.umSetGetData = null;
    });
    builder.addCase(getMoreSettingsOne.fulfilled, (state, action) => {
      state.umSetGetLoading = false;
      state.umSetGetSuccess = true;
      state.umSetGetError = false;
      state.umSetGetMessage = action.payload.data.message;
      state.umSetGetData = action.payload.data.data;
    });
    builder.addCase(getMoreSettingsOne.rejected, (state, action) => {
      state.umSetGetLoading = false;
      state.umSetGetSuccess = false;
      state.umSetGetError = true;
      // state.umSetGetMessage = action.payload.data.message;
      state.umSetGetData = null;
    });
    // To create branch
    builder.addCase(saveMoreSettingsOne.pending, (state, action) => {
      state.umSetLoading = true;
      state.umSetSuccess = false;
      state.umSetError = false;
      state.umSetMessage = null;
    });
    builder.addCase(saveMoreSettingsOne.fulfilled, (state, action) => {
      state.umSetLoading = false;
      state.umSetSuccess =
        action.payload.status == 200
          ? action.payload.data.status == true
            ? true
            : false
          : false;
      state.umSetError =
        action.payload.status == 200
          ? action.payload.data.status == true
            ? false
            : true
          : true;
      state.umSetMessage =
        action.payload.status == 200
          ? action.payload.data.status == true
            ? action.payload.data.message
            : action.payload.data.message
          : action.payload.response.data.message;
    });
    builder.addCase(saveMoreSettingsOne.rejected, (state, action) => {
      state.umSetLoading = false;
      state.umSetSuccess = false;
      state.umSetError = true;
      state.umSetMessage = action.payload.data.message;
    });
  },
});

export const { initMoreSettState, initAttModule } = moreSettingSlice.actions;

export default moreSettingSlice.reducer;
